module.exports = __webpack_public_path__ + "img/prevent.6f16aa88.jpg";